import noise from '@/assets/noise.png'
import { css, makeStyles } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  container: ({ colors, grid, spacing }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    min-height: calc(100vh - 60px);
    padding: 0 ${spacing.xs};
    background: linear-gradient(
      252.46deg,
      ${colors.brand.primary[400]} 0%,
      ${colors.brand.primary[500]} 100%
    );
    background-size: 400% 400%;
    animation: gradient 10s ease infinite;
    @media screen and (max-height: ${grid.breakpoint.md}) {
      min-height: 100vh;
    }

    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  `,

  changePasswordSuccess: ({ grid }) => css`
    position: absolute;
    background-image: url(${noise});
    background-position: center;
    background-size: cover;
    height: calc(100vh - 60px);
    width: 100%;
    @media screen and (max-height: ${grid.breakpoint.md}) {
      min-height: 100vh;
    }
  `,
  timeZoneSection: ({ colors, spacing, fontSizes, grid }) => css`
    bottom: ${spacing.md};
    position: fixed;
    margin: 0 ${spacing.xs} 0 ${spacing.xs};
    @media screen and (max-height: ${grid.breakpoint.md}) {
      position: relative;
      bottom: 0px;
    }
    p {
      font-size: ${fontSizes.xs};
      color: ${colors.neutral[300]};
      margin-top: ${spacing.xxs};
      @media screen and (max-width: ${grid.breakpoint.md}) {
        text-align: center;
      }
    }
  `,

  successCard: ({ colors, border, spacing, shadow }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 466px;
    padding: ${spacing.md} 40px;
    border-radius: ${border.radius.md};
    background-color: ${colors.background.white};
    box-shadow: ${shadow[3]};
    box-sizing: border-box;
  `,

  linkSupport: ({ colors, grid, spacing }) => css`
    color: ${colors.background.white};
    margin-top: ${spacing.xs};
    @media screen and (max-width: ${grid.breakpoint.md}) {
      margin: ${spacing.md};
    }
    &:hover {
      color: ${colors.background.white};
    }
  `,

  subtitle: ({ spacing }) => css`
    margin: ${spacing.xxs} 0;
  `,
})

export { useStyles }
